<template>
  <div class="ver-farmaco">
    <h3 class="text-center mb-3 font-weight-bold">Ver Item Farmaco</h3>

    <b-card class="section-card">
      <h5 class="section-title">Información del Ítem</h5>
      <b-row class="mt-1">
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Código</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ medicamento.codigo || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Presentación</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ medicamento.presentacion || 'No disponible' }}</span>
        </b-col>
        <b-col md="4" class="mb-1">
          <small class="text-muted d-block">Nombre</small>
          <span class="font-weight-bold h5 mb-0 d-block">{{ medicamento.nombre || 'No disponible' }}</span>
        </b-col>
      </b-row>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Precios</h5>
      <table class="table table-sm table-precios">
        <thead>
          <tr>
            <th>Entidad</th>
            <th class="text-center">Nivel</th>
            <th class="text-right">Precio</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="fila in filasPrecios" :key="fila.entidad">
            <td class="font-weight-bold">{{ fila.entidad }}</td>
            <td class="text-center">{{ fila.nivel }}</td>
            <td class="text-right">{{ fila.precio }}</td>
          </tr>
        </tbody>
      </table>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Estados de Cobertura</h5>
      <div class="d-flex flex-wrap">
        <div class="estado-chip mr-4 mb-2" v-for="estado in estadosCobertura" :key="estado.label">
          <span :class="estado.activo ? 'text-success' : 'text-danger'">
            <i :class="estado.activo ? 'fas fa-check-circle' : 'fas fa-minus-circle'" class="mr-1"></i>
            {{ estado.label }}
          </span>
        </div>
        <div class="estado-chip mr-4 mb-2">
          <span class="text-success">
            <i class="fas fa-check-circle mr-1"></i>Activo
          </span>
        </div>
        <div class="estado-chip mr-4 mb-2">
          <span class="text-danger">
            <i class="fas fa-minus-circle mr-1"></i>Inactivo
          </span>
        </div>
      </div>
    </b-card>

    <b-card class="section-card">
      <h5 class="section-title">Establecimientos</h5>
      <b-row>
        <b-col md="6" v-for="est in establecimientos" :key="est.id">
          <div class="d-flex align-items-center mb-2">
            <span class="font-weight-bold mr-2 text-uppercase">{{ est.nombre }}</span>
            <span :class="est.activo ? 'text-success' : 'text-danger'">
              <i :class="est.activo ? 'fas fa-check-circle' : 'fas fa-times-circle'" class="mr-1"></i>
              {{ est.activo ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { comprobarPermisos } from "@/shared/helpers";
import { establecimientosService } from '@/views/administracion/services';
import { BContainer, BRow, BCol, BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue';

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
  },
  props: ['token'],

  data() {
    return {
      medicamento: {
        id: '',
        token: '',
        nombre: '',
        codigo: '',
        presentacion: '',
        numMax: 0,
        precioNeto: 0,
        precioTecho: 0,
        establecimiento: '',
        estado: 0,
        estadoJson: {},
        precioJson: {},
      },
      estadoJson: {},
      precioJson: {},
      establecimientosList: [],
    };
  },
  async created() {
    const tokenMedicamento = this.token;
    comprobarPermisos(this.$route);
    this.establecimientosList = await establecimientosService.getForSelect();
    this.fetchMedicamento(tokenMedicamento);
  },
  methods: {
    async fetchMedicamento(tokenMedicamento) {
      const query = `
        query ObtenerMedicamento($tokenMedicamento: String!) {
          medicamento(tokenmedicamento: $tokenMedicamento) {
            medicamento {
              id
              token
              nombre
              codigo
              estado
              numMax
              precioNeto
              precioTecho
              presentacion
              establecimiento
              estadoJson
              precioJson
            }
            message
            status
          }
        }
      `;

      const variables = {
        tokenMedicamento: tokenMedicamento,
      };

      try {
        const response = await axios.post(rutas.axios + 'api', { query, variables });
        if (response.data.data.medicamento.status === 'Success') {
          if (response.data.data.medicamento.medicamento) {
            const medicamentoData = response.data.data.medicamento.medicamento;
            this.medicamento = medicamentoData;
            this.estadoJson = this.parseFlexibleJson(medicamentoData.estadoJson);
            this.precioJson = this.parseFlexibleJson(medicamentoData.precioJson);
          }
        } else {
          console.error("Error al obtener el farmaco:", response.data.message);
        }
      } catch (error) {
        console.error("Error al realizar la consulta GraphQL:", error);
      }
    },

    parseFlexibleJson(value) {
      if (!value) return {};
      if (typeof value === 'object') return value;
      try {
        return JSON.parse(value);
      } catch (e) {
        try {
          const fixed = value
            .replace(/'/g, '"')
            .replace(/([{,]\s*)([a-zA-Z0-9_]+)\s*:/g, '$1"$2":');
          return JSON.parse(fixed);
        } catch (error) {
          console.warn('No se pudo parsear JSON flexible', value);
          return {};
        }
      }
    },
  },

  computed: {
    filasPrecios() {
      const format = (valor) => {
        const num = Number(valor || 0);
        return `$${num.toFixed(2)}`;
      };
      return [
        { entidad: 'ISSFA N1', nivel: 'N1', precio: format(this.precioJson.issfa_n1) },
        { entidad: 'ISSFA N2', nivel: 'N2', precio: format(this.precioJson.issfa_n2) },
        { entidad: 'IESS N1',  nivel: 'N1', precio: format(this.precioJson.iess_n1) },
        { entidad: 'ISSPOL N1', nivel: 'N1', precio: format(this.precioJson.isspol_n1) },
        { entidad: 'PARTICULAR', nivel: '-', precio: format(this.precioJson.particular ?? this.medicamento.precioNeto) },
        { entidad: 'TECHO', nivel: '-', precio: format(this.medicamento.precioTecho) },
      ];
    },
    establecimientos() {
      const estIds = (this.medicamento.establecimiento || '')
        .split(',')
        .map(e => e.trim())
        .filter(Boolean);

      return (this.establecimientosList || []).map(est => ({
        id: est.value ? String(est.value) : '',
        nombre: est.text,
        activo: estIds.includes(String(est.value)),
      }));
    },
    estadosCobertura() {
      return [
        { label: 'IESS',       activo: !!this.estadoJson.iess },
        { label: 'ISSFA',      activo: !!this.estadoJson.issfa },
        { label: 'ISSPOL',     activo: !!this.estadoJson.isspol },
        { label: 'PARTICULAR', activo: !!this.estadoJson.particular },
      ];
    }
  },
};
</script>

<style scoped>
.ver-farmaco h5 {
  font-weight: 600;
}
.table th,
.table td {
  vertical-align: middle;
}
.estado-chip {
  padding: 4px 0;
}
.section-card {
  background: #f7f9fc;
}
.section-title {
  font-weight: 700;
  margin-bottom: 6px;
}
.table-precios thead th {
  background: #dfe3e8;
}
.table-precios tbody tr:nth-child(every) {
  background: #fff;
}
</style>
